// Shared palette for inline styles, matching Sidekick desktop and web. Brand
// and text colours align with the Semantic UI Less theme
// (src/semantic-ui/site/globals/site.variables).
export const colors = {
  teal: "#58b9b7",
  violet: "#98a0d9",
  purple: "#ca98d9",
  blue: "#98b6d9",
  // Online meetings, as in Sidekick desktop
  call: "#6f9df5",
  green: "#5cb958",
  amber: "#e0b34d",
  red: "#e85858",
  amberTint: "rgba(224, 179, 77, 0.1)",
  amberBorder: "rgba(224, 179, 77, 0.4)",
  greenTint: "rgba(92, 185, 88, 0.12)",
  greenText: "#9edb9b",
  tealTint: "rgba(88, 185, 183, 0.12)",
  tealBorder: "rgba(88, 185, 183, 0.5)",
  tealText: "#9ee0de",
  violetTint: "rgba(152, 160, 217, 0.12)",
  violetBorder: "rgba(152, 160, 217, 0.3)",
  redTint: "rgba(232, 88, 88, 0.08)",
  redBorder: "rgba(232, 88, 88, 0.3)",
  errorText: "#f2a19a",
  amberText: "#e8c56f",
  pageBackground: "#1b1b27",
  sidebar: "#171722",
  surface: "#222333",
  raised: "#2a2b3e",
  dialog: "#1f2030",
  border: "rgba(255, 255, 255, 0.08)",
  borderStrong: "rgba(255, 255, 255, 0.12)",
  text: "#ffffff",
  textStrong: "rgba(255, 255, 255, 0.85)",
  textMuted: "rgba(255, 255, 255, 0.6)",
  textLight: "rgba(255, 255, 255, 0.5)",
  textFaint: "rgba(255, 255, 255, 0.4)",
  onPrimary: "#10201f",
};

export const fonts = {
  system: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
};

export const style = {
  // Spread onto Semantic <Button style>, matching Btn in components/ui
  primaryButton: {
    color: colors.onPrimary,
    background: colors.teal,
    border: "1px solid transparent",
    boxShadow: "none",
  },
  secondaryButton: {
    color: colors.text,
    background: colors.raised,
    border: `1px solid ${colors.borderStrong}`,
    boxShadow: "none",
  },
  // AI actions (summarise, query)
  accentButton: {
    color: colors.text,
    background: "rgba(152, 160, 217, 0.18)",
    border: `1px solid ${colors.violetBorder}`,
    boxShadow: "none",
  },
  // Semantic Button at the same height as Btn md
  compactButton: { padding: "7px 12px", fontSize: "13px", lineHeight: "18px" },
  // Sidekick logo colours, deepened so white text reads. Pair with className
  // "sk-gradient" for the hover lift.
  gradientButton: {
    color: "#fff",
    background:
      "linear-gradient(120deg, #7d86e0 0%, #5f9fd6 50%, #2fa7a2 100%)",
    border: "1px solid transparent",
    boxShadow:
      "inset 0 1px 0 rgba(255, 255, 255, 0.35), 0 0 0 1px rgba(255, 255, 255, 0.06), 0 6px 18px -6px rgba(47, 167, 162, 0.6)",
    textShadow: "0 1px 1px rgba(0, 0, 0, 0.25)",
  },
};
